import axios from "axios";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { wsConnect } from "../utils/wsConnect";
import { getRunningSeries } from "../services/ContestSeries";
import { Dispatch } from "redux";
import {
  fetchContestsFailure,
  fetchContestsRequests,
  fetchContestsSuccess,
  updateContest,
} from "../redux/contests/actions";
import { selectAuth } from "../redux/selectors";

let wsConnected = false;

export const getContestId = async (seriesId) => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_URL_HXROAPI}/contests/by-series/${seriesId}`
  );
  return data.filter((item) => !["Closing", "Closed"].includes(item?.status));
};

// Util generate poolkey from contest
export const getContestSeriesKey = (contest) => {
  const { duration, assetType, instrumentPrices } = contest;

  return `${duration}-${assetType}-${instrumentPrices?.[0]?.instrument?.assetIdBase}`;
};

export const fetchContests =
  (contests?: any, seriesID?: string) => async (dispatch: Dispatch) => {
    if (contests && contests?.length) {
      contests.map((item) => {
        if (item.seriesId === seriesID) {
          dispatch(fetchContestsSuccess([item]));
        }
        return null;
      });
      return;
    }

    dispatch(fetchContestsRequests());
    try {
      // const series = await getRunningSeries();

      // const getContests = series
      //   .filter((s) => s.name.includes("BTC/USD") && s.id === seriesID)
      //   .map(({ id }) =>
      //     getContestId(id).then((contests) =>
      //       dispatch(fetchContestsSuccess(contests))
      //     )
      //   );

      await getContestId(seriesID).then((contests) =>
        dispatch(fetchContestsSuccess(contests))
      );
      // await Promise.all(getContests);
    } catch (err) {
      console.error("fetch contest failure", err);
      dispatch(fetchContestsFailure(err));
    }
  };

export default function useParimutuelConnect(opts: any = {}) {
  const dispatch = useDispatch();
  const auth = useSelector(selectAuth);
  const { seriesID } = opts;

  useEffect(() => {
    if (!opts.onOpen) {
      opts.onOpen = () => dispatch<any>(fetchContests([], seriesID));
    } else {
      const _onOpen = opts.onOpen;
      opts.onOpen = () => {
        dispatch<any>(fetchContests([], seriesID));
        _onOpen();
      };
    }

    if (wsConnected || !seriesID) {
      return;
    }
    wsConnect(
      `${process.env.REACT_APP_CONTESTS_WS}?subscriptionKey=${auth?.subscriptionKey}`,
      {
        retry: Infinity,
        ping: (ws) => setInterval(() => ws.send("ping"), 15000),
        onMessage: (evt) => {
          if (evt.data === "pong") {
            return;
          }
          const { type, arguments: contests } = JSON.parse(evt.data);
          if (type === "contestupdate") {
            dispatch<any>(updateContest(contests[0]));
          } else if (type === "contestsadded") {
            dispatch<any>(fetchContests(contests, seriesID));
          } else {
            console.error(`Unknown type: ${type}`);
          }
        },
        ...opts,
      }
    );

    wsConnected = true;

    return ()=>{
      wsConnected = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seriesID]);
}
